export const emptyContentCheck = (sentence: string, text: string) => {
  if (text === "") {
    alert(sentence);
    return false;
  } else {
    return true;
  }
};

export const finalCheck = (sentence: string, text: string) => {
  if (text !== null && text !== "") {
    if (window.confirm(sentence)) {
      return true;
    } else {
      return false;
    }
  }
};

// 사진 조건 체크
export const imgFileSize = (imgFile: any, sentence: string, i: number) => {
  // 용량
  if (imgFile[i].size > 1048576) {
    alert(`${sentence} ${imgFile[i].name}`);
    return false;
  } else {
    return true;
  }
};

export const allowedTypes = [
  "image/jpg",
  "image/gif",
  "image/png",
  "image/jpeg"
];

export const imgFileType = (imgFile: any, sentence: string, i: number) => {
  // 타입

  if (!allowedTypes.includes(imgFile[i].type)) {
    alert(sentence);
    return false;
  } else {
    return true;
  }
};

export const imgFileLen = (imgFile: any, sentence: string, Count: number) => {
  // 장 수
  if (imgFile.length > Count) {
    alert(sentence);
    return false;
  } else {
    return true;
  }
};

interface contentsCheckProps {
  imgFile: any;
  imgsSizeTkey: string;
  imgsTypeTkey: string;
  imgsLenTkey: string;
  t: (key: string) => string;
}

export const contentsCheck = (props: contentsCheckProps) => {
  const { imgFile, imgsSizeTkey, imgsTypeTkey, imgsLenTkey, t } = props;
  if (
    imgFileSize(imgFile, t(imgsSizeTkey), 0) &&
    imgFileType(imgFile, t(imgsTypeTkey), 0) &&
    imgFileLen(imgFile, t(imgsLenTkey), 1)
  ) {
    return true;
  } else {
    return false;
  }
};
